import type { ReactNode } from 'react'
import { InfoTooltip } from './InfoTooltip'

export interface ToggleFieldProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: ReactNode
  /** Explanatory InfoTooltip shown after the label. */
  tooltip?: string
  disabled?: boolean
}

// A labelled checkbox with an optional tooltip - the markup FieldRow's
// Critical toggle and other screens write by hand. PRD 39.
export function ToggleField({ checked, onChange, label, tooltip, disabled }: ToggleFieldProps) {
  return (
    <label className="flex w-fit items-center gap-2 text-body text-text-primary">
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      {label}
      {tooltip && <InfoTooltip text={tooltip} />}
    </label>
  )
}
